import React, { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Jumbotron} from "react-bootstrap";
import { MDBCard, MDBCardBody, MDBCardImage, MDBCardTitle, MDBCardText, MDBContainer, MDBView, MDBFooter } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faPlay, faLaptopCode, faIcons, faCogs, faUsers, faHandHoldingUsd, faUserShield,  } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core';
import FormPage from './contact';
import WavesPage from './wavecards';
import {getPosts} from './GetData'
import { Menu } from './menu';
library.add(faChevronLeft, faChevronRight, faPlay, faLaptopCode, faCogs, faUsers, faHandHoldingUsd);
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import { Testimonials } from './testimonials'
import { Cta } from './homecta';
import {SocialIcon} from 'react-social-icons';
import SubscribePage from './subscribe';
import {Link} from 'react-router-dom'


let cRight = new Date().getUTCFullYear();


class Main extends React.Component {

  

  constructor() {
  super()
  this.onHover = this.onHover.bind(this);
  this.state = {
    offset: 0,
    posts: []
  };
  
}

onHover(e) {
  e.target.style.cursor = "pointer";
}





  componentDidMount() {
    
    window.addEventListener('scroll', this.parallaxShift);
    let postUrl = `${getPosts}`;
    fetch(postUrl)
      .then(data => data.json())
      .then(data => {
        this.setState({
          posts: data
        })
        
      })
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.parallaxShift);
  }
  parallaxShift = () => {
    this.setState({
      offset: window.pageYOffset
    });
  };


  

  

  
render(){

  

  
  let listposts = this.state.posts.map((post, index) => {
    

    return (
      
      <Link to={`/blog/${post.slug}`} style={{ textDecoration: "None" }}>
        <div key={index} style={{ color: "black"}} >
        
        <MDBCardImage waves src={post.better_featured_image.media_details.sizes.large.source_url} style={{width: '100%', height: '200px', border: '1px, solid, black', position: 'relative'}}/>
        <MDBCardTitle>{post.title.rendered}</MDBCardTitle>
        <MDBCardBody>
          <MDBCardText dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
        </MDBCardBody>
      </div>
      </Link>
    )
  })

  return(

    

      <div>

        
    
      
      
    
    

      <section id="home">

        
        
        <div style={{ textAlign: "left", width: "100%", top: "0", color: "white", position: "absolute", fontSize: "2.5rem" }} className="businessName">
          
            <div style={{ position: "relative", zIndex: "3" }}>
          <Menu />
          </div>
          
          
          
          <div style={{ top: "32%", position: "relative", width: "100%", left: "5%"}}>
            
          <h1>Chris Barnbeck</h1>
              
                <div style={{fontSize: "35px", left: "15px", position: "relative"}}>
        
          
            Web Developer
  
           
        </div>
            <Cta />   
    
                
        
        
            
            
          </div>
          
          
          </div>

        
        
        
        <div className="videowrapper" style={{ backgroundPositionY: this.state.offset }}>
        <video autoPlay muted loop width="100%" height="100%" style={{ position: "relative", objectFit: "cover", zIndex: "-999",
            backgroundSize: "cover", transition: "1s opacity", background: "no-repeat scroll", bottom: this.state.offset / -1.35 }}
       src={(process.env.PUBLIC_URL + '/DroneVideo.mp4')}>        
       </video>
        </div>
        </section>
        
      <section id="portfolio">
        <div className="section websection" >
              
          <div style={{ maxWidth: "110px"}} className="webtext" >
            
          <h3 style={{color: "black"}}>Portfolio</h3>
          
          </div>

        <p className="webquote">

          A testament of my dedication to the craft.
            
          </p>
          
         
        </div>
        <div className="webcontent">
          <Fade bottom cascade>
        
          <div className="row" style={{width: '80%', display: "inline-flex"}}>
        <MDBContainer className="col-lg-4 mb-auto" lg="4" md="6" sm="4">
        <h4 style={{fontWeight: "bold", marginBottom: "25px"}}>I Develop</h4>
        <div>
          <FontAwesomeIcon className="icons" icon={faLaptopCode} />
          <h5>Websites</h5>
          <div style={{marginBottom: '10px'}}>
            Custom, responsive websites.
          </div>
          <FontAwesomeIcon className="icons" icon={faIcons} />
          <h5>Applications</h5>
                <div style={{ marginBottom: '10px' }}>
            Interactive applications designed to engage users.
            </div>
          <FontAwesomeIcon className="icons" icon={faUserShield} />
          <h5>Business Software</h5>
                <div style={{ marginBottom: '25px' }}>
            Software solutions for business data.
            </div>
        </div>
        
        </MDBContainer>

        <MDBContainer className="col-lg-4 mb-auto" lg="4" md="6" sm="4">
        <h4 style={{ fontWeight: "bold", marginBottom: "25px" }}>I Can Help You</h4>
          <FontAwesomeIcon className="icons" icon={faUsers} />
          <h5>Find New Customers</h5>
                <div style={{ marginBottom: '10px' }}>
            Grow your business with a website.
          </div>
          <FontAwesomeIcon className="icons" icon={faHandHoldingUsd} />
          <h5>Monetize Your Brand</h5>
              <div style={{ marginBottom: '10px' }}>
            Build a customer database and analyze KPIs.
            </div>
          <FontAwesomeIcon className="icons" icon={faCogs} />
          <h5>Automate Your Business</h5>
              <div style={{ marginBottom: '10px' }}>
            Develop useful applications to save time.
            </div>
        
            </MDBContainer>

            
            
          
        
            
            
            </div>

          
            <h4 className = "featuredclients">Featured Clients</h4>
            

          </Fade>

           <WavesPage/>

           <Testimonials />
          

        </div>
        </section>
          <section id="resume">
        <div className="websection" style={{background: "black"}} >
          <h3 className="resume">Résumé</h3>
          <p className="webquote" style={{color: "white"}}>

          An overview of my business experience and credentials.
            
          </p>
          </div>
        
        
      <MDBView>

        <div style={{background: "black", height: "100%"}}>

          <img className="img-fluid" alt="Responsive image" style={{marginBottom: "10%", marginTop: "1%", height: "100%", width: "720px", position: "relative", paddingBottom: "1.5%", }} src={process.env.PUBLIC_URL + '/react-src/src/resume.jpg'} />
            
          </div>

      </MDBView>
      
     </section>

        <section id="blog">
        <div className="websection" >

          
      
          <h3 style={{ maxWidth: '60px', color: "black" }} className="webtext">Blog</h3>

      

      <p className="webquote">

          A thought provoking online journal. Subscribe & Enjoy!
            
          </p>
      
      </div>

      <div className="marketingcontent">

        

          
          <h3 className="webtext" style={{ borderColor:"#06073C", width: "170px", color: '#06073C', marginBottom: "25px"}}>Recent Posts</h3>
          <Slide left>
        <div className="cardcontainer">
        <div className="row">

          
          
                <MDBCard className="col-lg-3 shakingCards" style={{ width: "20rem" }} onMouseOver={this.onHover}>
            
                  {listposts[2]}
              
          </MDBCard>
          

          
                <MDBCard className="col-lg-3 shakingCards" style={{ width: "20rem" }} onMouseOver={this.onHover}>
            
                  {listposts[1]}
              
            
          </MDBCard>
        

          
          <MDBCard className="col-lg-3 shakingCards" style={{ width: "20rem" }} onMouseOver={this.onHover}>
              {listposts[0]}
                
              
            
          </MDBCard>
          </div>
        
        </div>
          </Slide>
      </div>
        
        <Fade bottom>
        <Jumbotron className="subjumbo" style={{marginTop: "25px", color: 'black', position: 'relative', width: '100%' }}>
          <h4 style={{ marginBottom: '25px' }}>Subscribe to get updates on my latest articles!</h4>
            <p>It's free and you can <Link to={`/unsubscribe`} style={{color:"red"}}>unsubscribe</Link> any time.</p>
          <div style={{display: "inline-block"}}>
            <SubscribePage required/>
          </div>
        </Jumbotron>
        </Fade>
      </section>

      <section id="contact">
      <div className="section websection" style={{color: "white", background: "black"}} >
          <h3 style={{ maxWidth: '100px', borderColor: "white" }} className="webtext">Contact</h3>
        <p className="webquote">

          Let's start on your project!
            
          </p>
        </div>
                
          
          <MDBView img="true" className="conback" style={{
            flex: '1',
            width: '100%',
            height: '100vh', resizeMode: 'cover', position: 'relative'
          }} src={process.env.PUBLIC_URL + '/contact.jpeg'} alt="background">





          
          <div className="formposition" style={{ textAlign: 'center', width: 'auto', position: 'relative', overflow: 'hidden', height: "auto"}}>
            <FormPage style={{position: "absolute"}}></FormPage>
          
          
          </div>

        
          

          </MDBView>
         
      
      </section>
      <MDBFooter className="align-bottom">
        <div style={{ height: "auto", position: "relative" }}>


          <footer className="footer">
            <div className="footertext">
              © {cRight}  All Rights Reserved <a href="https://barnbeckmedia.com" style={{ color: "red" }}> Barnbeck Media LLC</a>

            </div>

            <SocialIcon style={{ marginTop: "2px" }} url="https://www.linkedin.com/in/thebarn" />
            <SocialIcon style={{ marginTop: "2px" }} url="https://github.com/cmsilvabarnbeck" />
          </footer>

        </div>
      </MDBFooter>
      
      </div> 
      
    
  

  

   
      
    );
    
    
        }
        
      }

      export {Main}; 
